import Misc from './misc';

/*
  Usage:

  Add your link:
  <a data-lightbox-id="[yourlightbox-id]" class="lightbox-trigger" href="#">Button here</a>

  Create your lightbox:
  <div id="[yourlightbox-id]" class="lightbox-wrapper" style="display:none">
    <div class="lightbox-content">
    <div class="lightbox-inner">
      <a href="#" class="op-close">Close</a>
      [YOUR CONTENT HERE]
    </div>
    </div>
    <div class="lightbox-canvas"></div>
  </div>

*/

class ModalLightbox {

  constructor(options) {

    // List of handlers
    this.typeOfLightbox = 'default';
    this.targetLightbox = options.hasOwnProperty('targetLightbox') ? options.targetLightbox : false, 
    this.onOpen = options.hasOwnProperty('onOpen') ? options.onOpen : false;
    this.onClick = this.onClick.bind(this);
    this.closeLightboxByButton = this.closeLightboxByButton.bind(this);
    this.enableEscKey = this.enableEscKey.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);

    // List of <a data-lightbox-id="[yourlightbox-id"]></a>
    this.triggerList = Array.prototype.slice.call(document.querySelectorAll(options.trigger));
    this.triggerList.forEach(item => {
      item.addEventListener('click', this.onClick);
    });

  }

  onClick(event) {
    event.preventDefault();
    
    // Get the lightbox ID from <a data-lightbox-id=""></a>
    let lightboxTargetSelector = false;
    
    if (this.targetLightbox) {
      lightboxTargetSelector = this.targetLightbox;
    } else {
      lightboxTargetSelector = `#${event.currentTarget.dataset.lightboxId}`;
    }

    let lightboxWrapper = document.querySelector(lightboxTargetSelector);

    // If lightbox id doesn't exist
    if (lightboxWrapper === null) return console.error('Lightbox not found');

    return this.openLightbox(lightboxWrapper);
  }

  openLightbox(lightboxWrapper) {
    lightboxWrapper.style.display = '';

    document.body.style.overflow = 'hidden';
    lightboxWrapper.classList.add('on-transition');

    const afterAnimation = () => {
      lightboxWrapper.classList.remove('on-transition');
      lightboxWrapper.classList.add('active');

      // Listen to certain events after is open
      document.addEventListener('keyup', this.enableEscKey);

      document.addEventListener('click', this.handleOutsideClick);
      // ['click','touchstart'].forEach( item => {
      //     document.addEventListener(item, this.handleOutsideClick );
      // })

      if(lightboxWrapper.querySelector('.op-close')) {
        lightboxWrapper.querySelector('.op-close')
          .addEventListener('click', this.closeLightboxByButton);
      } else {
        console.warn('Closing trigger element ".op-close" Not Found');
      }

      // Optional Callback
      typeof this.onOpen === 'function' && this.onOpen();

      // This action should be always at the end
      lightboxWrapper
        .removeEventListener(Misc.getAnimations(), afterAnimation);
    };

    Misc.getAnimations() && lightboxWrapper
      .addEventListener(Misc.getAnimations(), afterAnimation);

  }

  enableEscKey(event) {
    if (event.keyCode === 27) {
      this.closeLightbox();
    }
  }

  handleOutsideClick(event) {
    const lightboxWrapper = document.querySelector('.lightbox-wrapper.active .lightbox-inner');
    Misc.hasClickedOutside(lightboxWrapper, event.target).then(() => {
      this.closeLightbox();
    });
  }

  closeLightboxByButton(event) {
    event.preventDefault();
    this.closeLightbox();
  }

  closeLightbox() {
    const lightboxWrapper = document.querySelector('.lightbox-wrapper.active');

    document.removeEventListener('click', this.handleOutsideClick);
    // ['click','touchstart'].forEach( item => {
    //     document.removeEventListener(item, this.handleOutsideClick );
    // });

    lightboxWrapper.querySelector('.op-close')
      .removeEventListener('click', this.closeLightboxByButton);

    lightboxWrapper.style.animationDirection = 'reverse';
    lightboxWrapper.classList.add('on-transition');
    lightboxWrapper.classList.remove('active');

    const afterAnimation = () => {
      lightboxWrapper.classList.remove('on-transition');
      lightboxWrapper.style.animationDirection = '';
      lightboxWrapper.style.display = 'none';
      document.body.style.overflow = '';

      document.removeEventListener('keyup', this.enableEscKey);
      document.removeEventListener('click', this.handleOutsideClick);

      lightboxWrapper
        .removeEventListener(Misc.getAnimations(), afterAnimation);
    };

    Misc.getAnimations() && lightboxWrapper
      .addEventListener(Misc.getAnimations(), afterAnimation);

  }

}

document.addEventListener('DOMContentLoaded', function(){

  new ModalLightbox({ // eslint-disable-line no-unused-vars
    trigger: 'a[href="/#sign-up-listings"]',
    targetLightbox: '#lightbox-sign-up-listings'
  });

  new ModalLightbox({ // eslint-disable-line no-unused-vars
    trigger: '.lightbox-cf7mailsent-trigger',
    targetLightbox: '#lightbox-cf7mailsent'
  });

  // For testing purposes
  // document.querySelector('a[href="/#sign-up-listings"]').click();
  
});